<i18n>
{
  "fr": {
    "luggage-info": {
      "outward": "Pas de bagages inclus à l'aller | Un bagage inclus à l'aller | {n} bagages inclus à l'aller",
      "return": "Pas de bagages inclus au retour | Un bagage inclus au retour | {n} bagages inclus au retour",
      "same-amount": "Pas de bagages inclus à l'aller et au retour | Un bagage inclus à l'aller et au retour | {n} bagages inclus à l'aller et au retour",
      "unknown": "Pas d'information fiable pour les bagages"
    }
  },
  "en": {
    "luggage-info": {
      "outward": "No luggage included on the outward journey | One luggage included on the outward journey | {n} luggage included on the outward journey",
      "return": "No luggage included on the return journey | One luggage included on the return journey | {n} luggage included on the return journey",
      "same-amount": "No luggage included on the outward and return journey | ONe luggage included on the outward and return journey | {n} luggage included on the outward and return journey",
      "unknown": "No reliable luggage information"
    }
  }
}
</i18n>

<template>
  <v-list-item>
    <v-list-item-avatar>
      <v-icon
        v-if="luggageIncludedQuantity().outward > 0 && luggageIncludedQuantity().return > 0"
        color="primary"
      >
        mdi-bag-carry-on
      </v-icon>
      <v-icon
        v-else
        color="grey"
      >
        mdi-bag-carry-on-off
      </v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-subtitle>
        {{ luggageIncludedInfo() }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'LuggageIncludedInfo',
  props: {
    outwardIncludedLuggage: {
      type: Object,
      required: true
    },
    returnIncludedLuggage: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState({
      travelType: state => state.fb.searchResults.travelType
    })
  },
  methods: {
    luggageIncludedQuantity () {
      return {
        outward: this.outwardIncludedLuggage?.bag_quantity,
        return: this.returnIncludedLuggage?.bag_quantity
      }
    },
    luggageIncludedInfo () {
      const quantity = this.luggageIncludedQuantity()
      if (this.travelType === 'one-way') {
        return this.$i18n.tc('luggage-info.outward', quantity.outward)
      }
      if (this.travelType === 'two-way' && _.isNumber(quantity.outward) && _.isNumber(quantity.return)) {
        // check if we can simplify the info to display
        if (quantity.outward === quantity.return) {
          return this.$i18n.tc('luggage-info.same-amount', quantity.outward)
        } else {
          const outwardSentence = this.$i18n.tc('luggage-info.outward', quantity.outward)
          const returnSentence = this.$i18n.tc('luggage-info.return', quantity.return)
          return `${outwardSentence}, ${returnSentence}`
        }
      }
      return this.$i18n.t('luggage-info.unknown')
    }
  }
}
</script>

<style scoped>
</style>
